var React = require('react');

function Trophy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 14.66v1.626a2 2 0 0 1-.976 1.696A5 5 0 0 0 7 21.978","key":0}),React.createElement("path",{"d":"M14 14.66v1.626a2 2 0 0 0 .976 1.696A5 5 0 0 1 17 21.978","key":1}),React.createElement("path",{"d":"M18 9h1.5a1 1 0 0 0 0-5H18","key":2}),React.createElement("path",{"d":"M4 22h16","key":3}),React.createElement("path",{"d":"M6 9a6 6 0 0 0 12 0V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1z","key":4}),React.createElement("path",{"d":"M6 9H4.5a1 1 0 0 1 0-5H6","key":5})]);
}

Trophy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-trophy-icon lucide-trophy"};

module.exports = Trophy;

Trophy.default = Trophy;
